import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { SNItem } from '../models/snitem';

@RegisterItem()
export class SNDocument extends SNItem {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.SNDocument';
    }

    public clone(): any {
        return new SNDocument();
    }
}

